export const createGameUserStatesSlice = ({ initialUserStates })=>()=>({
            gameUserStates: {
                userStates: initialUserStates,
                getUserState: (color)=>{
                    const userState = initialUserStates.find((user)=>user.selectedColor === color);
                    if (!userState) throw new Error(`User state not found for color ${color}`);
                    return userState;
                }
            }
        });
